import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { MultiSelect } from 'slovlex-idsk-react-components';
import { Col, Row } from 'idsk-react-components';
import routes from '../../../routing/routes';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { useClient } from '../../../context/ClientStatusContext';
import VyhlasenievZbierkeZakonovButtons from './component/VyhlasenievZbierkeZakonovButtons';
import PredpisZbierky from '../../../model/legislativnyMaterial/PredpisZbierky';
import useSearchNovelizovanyPredpisList
  from '../../LegislativnyMaterial/LegislativnyMaterialCreateUpdate/hook/useSearchNovelizovanyPredpisList';
import {
  MAX_MULTISELECT_RESULT,
  SHOW_ALL_MAX_RESULT,
} from '../../../constants/MultiSelectConstant';
import { vyhlasenievZbierke } from '../../../client/pracovnyKrok/vyhlasenievZbierkeClient';
import useFieldErrorMessages from '../../useFieldErrorMessages';

const VyhlasenievZbierkeZakonov = (): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();

  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();

  const [vyhlasenyPodCislomPredpisuList, setVyhlasenyPodCislomPredpisuList] = useState<Array<PredpisZbierky>>([]);

  const {
    wrapClient: VyhlasitvZbierkeClient,
    status: VyhlasitvZbierkeClientStatus,
  } = useClient(vyhlasenievZbierke);

  const handleVyhlasitvZbierke = async (): Promise<void> => {
    await VyhlasitvZbierkeClient(type, year, index, pracovnyKrokId, vyhlasenyPodCislomPredpisuList);
    navigate(routes.procesy.detail.withParams(type, year, index));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  const [searchTextNovelizovanyPredpis, setSearchTextNovelizovanyPredpis] = useState('');
  const [limit, setLimit] = useState(MAX_MULTISELECT_RESULT);

  const {
    novelizovanyPredpisList,
    novelizovanyPredpisListStatus,
  } = useSearchNovelizovanyPredpisList(
    searchTextNovelizovanyPredpis,
    limit,
  );

  return (
    <>
      <Row>
        <Col width="two-thirds">
          <MultiSelect
            handleShowAll={() => {
              setLimit(SHOW_ALL_MAX_RESULT);
            }}
            loading={novelizovanyPredpisListStatus.loading}
            withShowAllButton={(limit === MAX_MULTISELECT_RESULT
                && novelizovanyPredpisList.length === MAX_MULTISELECT_RESULT)
              || (limit === SHOW_ALL_MAX_RESULT && novelizovanyPredpisList.length <= MAX_MULTISELECT_RESULT)}
            searchText={searchTextNovelizovanyPredpis}
            setSearchText={(text) => {
              setSearchTextNovelizovanyPredpis(text);
              setLimit(MAX_MULTISELECT_RESULT);
            }}
            label="Vyhlásený pod číslom predpisu (alebo predpisov)"
            required
            hint="Začnite písať a vyberte z ponúkaných možností."
            width="three-quarters"
            data={novelizovanyPredpisList}
            itemListAttribute="popis"
            dataAttributesToShow={[{
              key: 'popis',
              label: '',
            }]}
            selectedItemList={vyhlasenyPodCislomPredpisuList}
            setSelectedItemList={(selectedItems: PredpisZbierky[]) => {
              setVyhlasenyPodCislomPredpisuList(selectedItems
                .sort((a, b) => Intl.Collator()
                  .compare(a.popis, b.popis)));
              clearFieldErrorMessage('cisloPredpisu');
            }}
            maxResults={SHOW_ALL_MAX_RESULT}
            error={getFieldErrorMessage('cisloPredpisu')}
          />
        </Col>
      </Row>
      <VyhlasenievZbierkeZakonovButtons
        onClick={handleVyhlasitvZbierke}
        loading={VyhlasitvZbierkeClientStatus.loading}
      />
    </>
  );
};

export default VyhlasenievZbierkeZakonov;
